import { useApi } from '@/lib/api';

export const useClassroomApi = () => {
  const api = useApi('v1');

  return {
    // Get all classrooms
    getAllClassrooms: async () => {
      const response = await api.get('/classrooms');
      if (response.error) {
        return { data: null, error: response.error };
      }
      return { data: response.data?.data || [], error: null };
    },

    // Create a new classroom
    createClassroom: async (classroomData) => {
      const response = await api.post('/classrooms', classroomData);
      if (response.error) {
        return { data: null, error: response.error };
      }
      return { data: response.data?.data, error: null };
    }
  };
};